// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oyemL6 {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.o7sqHE {
  background: var(--surface-primary, #ffffff);
  border-radius: 4px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  height: 100%;
}

.Ptn66h {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--border-default, #f2f2f2);
  padding: 0 12px;
  min-height: 48px;
  position: relative;
}

.uwq8Dj {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--brand-primary, #d64000);
  margin: 0;
  padding: 8px 8px 6px;
  line-height: 1.424;
  position: relative;
}

.uwq8Dj::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: var(--brand-primary, #d64000);
}

.DEXjfg {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--brand-primary, #d64000);
  background: none;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.DEXjfg:hover {
  opacity: 0.8;
}

.C3EkW5 {
  width: 14px;
  height: 14px;
  filter: brightness(0) saturate(100%) invert(32%) sepia(96%) saturate(2944%) hue-rotate(358deg) brightness(91%)
    contrast(91%);
}

.u7bxYH {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 60px 20px 40px;
  height: 100%;
}

.xvARKn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
}

.tpqXC_ {
  width: 72px;
  height: 72px;
}

.NdmVCC {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #1f1f1f);
  margin: 0;
  line-height: 1.5;
}

.kXO_GC {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-secondary, #666666);
  margin: 0;
  line-height: 1.5;
  max-width: 320px;
}

.C1i24X {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: auto !important;
  padding: 12px 24px;
  font-weight: 600;
  min-width: 280px;
  background-color: var(--brand-primary, #d64000) !important;
  color: white !important;
  border: none !important;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.C1i24X:hover {
  background-color: #b23600 !important;
}

.C1i24X:focus {
  outline: 2px solid var(--brand-primary, #d64000);
  outline-offset: 2px;
}

.tgxHYM {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

/* Loading and Error states */
.jEGoMu {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  min-height: 100%;
  height: 100%;
}

.ILWGMk {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
}

.X68yY5 {
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--text-error, #dc0a0a);
  margin: 0;
}

/* Keys list styles */
.gd7mHn {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  height: 100%;
}

/* Responsive styles */
@media (max-width: 768px) {
  .Ptn66h {
    padding: 0 8px;
    min-height: 44px;
  }

  .uwq8Dj {
    font-size: 14px;
    padding: 8px;
  }

  .DEXjfg {
    font-size: 14px;
    padding: 8px;
  }

  .u7bxYH {
    padding: 40px 16px 32px;
    gap: 24px;
  }

  .tpqXC_ {
    width: 64px;
    height: 64px;
  }

  .NdmVCC {
    font-size: 16px;
  }

  .kXO_GC {
    font-size: 13px;
  }

  .C1i24X {
    min-width: 200px;
  }
}

@media (max-width: 480px) {
  .Ptn66h {
    padding: 0 8px;
    min-height: 40px;
  }

  .uwq8Dj {
    font-size: 14px;
    padding: 8px;
  }

  .DEXjfg {
    font-size: 12px;
    padding: 6px;
  }

  .C3EkW5 {
    width: 12px;
    height: 12px;
  }

  .u7bxYH {
    padding: 32px 12px 24px;
    gap: 20px;
  }

  .tpqXC_ {
    width: 56px;
    height: 56px;
  }

  .NdmVCC {
    font-size: 14px;
  }

  .kXO_GC {
    font-size: 12px;
  }

  .C1i24X {
    width: auto !important;
    min-width: 200px;
  }

  .gd7mHn {
    padding: 16px 12px;
    gap: 6px;
  }

  .SjiVqV {
    padding: 12px;
    gap: 12px;
  }

  .G5zmMY {
    width: 20px;
    height: 20px;
  }

  .G5zmMY img {
    width: 14px;
    height: 14px;
  }

  .bbI3h6,
  .zETYlz {
    font-size: 13px;
  }

  .FCPhFf,
  .iqv9vf {
    width: 28px;
    height: 28px;
  }

  .FCPhFf img,
  .iqv9vf img {
    width: 14px;
    height: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixKeysList/PixKeysList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;iBACe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0DAA0D;EAC1D,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n\n.card {\n  background: var(--surface-primary, #ffffff);\n  border-radius: 4px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n  height: 100%;\n}\n\n.titleContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--border-default, #f2f2f2);\n  padding: 0 12px;\n  min-height: 48px;\n  position: relative;\n}\n\n.title {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--brand-primary, #d64000);\n  margin: 0;\n  padding: 8px 8px 6px;\n  line-height: 1.424;\n  position: relative;\n}\n\n.title::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: var(--brand-primary, #d64000);\n}\n\n.newKeyButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--brand-primary, #d64000);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.newKeyButton:hover {\n  opacity: 0.8;\n}\n\n.newKeyIcon {\n  width: 14px;\n  height: 14px;\n  filter: brightness(0) saturate(100%) invert(32%) sepia(96%) saturate(2944%) hue-rotate(358deg) brightness(91%)\n    contrast(91%);\n}\n\n.emptyStateContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n  padding: 60px 20px 40px;\n  height: 100%;\n}\n\n.emptyStateContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  text-align: center;\n}\n\n.emptyStateIcon {\n  width: 72px;\n  height: 72px;\n}\n\n.emptyStateText {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary, #1f1f1f);\n  margin: 0;\n  line-height: 1.5;\n}\n\n.emptyStateDescription {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-secondary, #666666);\n  margin: 0;\n  line-height: 1.5;\n  max-width: 320px;\n}\n\n.registerButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: auto !important;\n  padding: 12px 24px;\n  font-weight: 600;\n  min-width: 280px;\n  background-color: var(--brand-primary, #d64000) !important;\n  color: white !important;\n  border: none !important;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.registerButton:hover {\n  background-color: #b23600 !important;\n}\n\n.registerButton:focus {\n  outline: 2px solid var(--brand-primary, #d64000);\n  outline-offset: 2px;\n}\n\n.buttonIcon {\n  width: 16px;\n  height: 16px;\n  filter: brightness(0) invert(1);\n}\n\n/* Loading and Error states */\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 20px;\n  min-height: 100%;\n  height: 100%;\n}\n\n.errorContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 20px;\n}\n\n.errorText {\n  font-family: 'Source Sans 3', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-error, #dc0a0a);\n  margin: 0;\n}\n\n/* Keys list styles */\n.keysContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 24px;\n  height: 100%;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .titleContainer {\n    padding: 0 8px;\n    min-height: 44px;\n  }\n\n  .title {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .newKeyButton {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .emptyStateContainer {\n    padding: 40px 16px 32px;\n    gap: 24px;\n  }\n\n  .emptyStateIcon {\n    width: 64px;\n    height: 64px;\n  }\n\n  .emptyStateText {\n    font-size: 16px;\n  }\n\n  .emptyStateDescription {\n    font-size: 13px;\n  }\n\n  .registerButton {\n    min-width: 200px;\n  }\n}\n\n@media (max-width: 480px) {\n  .titleContainer {\n    padding: 0 8px;\n    min-height: 40px;\n  }\n\n  .title {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .newKeyButton {\n    font-size: 12px;\n    padding: 6px;\n  }\n\n  .newKeyIcon {\n    width: 12px;\n    height: 12px;\n  }\n\n  .emptyStateContainer {\n    padding: 32px 12px 24px;\n    gap: 20px;\n  }\n\n  .emptyStateIcon {\n    width: 56px;\n    height: 56px;\n  }\n\n  .emptyStateText {\n    font-size: 14px;\n  }\n\n  .emptyStateDescription {\n    font-size: 12px;\n  }\n\n  .registerButton {\n    width: auto !important;\n    min-width: 200px;\n  }\n\n  .keysContainer {\n    padding: 16px 12px;\n    gap: 6px;\n  }\n\n  .keyItem {\n    padding: 12px;\n    gap: 12px;\n  }\n\n  .keyIcon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .keyIcon img {\n    width: 14px;\n    height: 14px;\n  }\n\n  .keyLabel,\n  .keyValue {\n    font-size: 13px;\n  }\n\n  .copyButton,\n  .deleteButton {\n    width: 28px;\n    height: 28px;\n  }\n\n  .copyButton img,\n  .deleteButton img {\n    width: 14px;\n    height: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `oyemL6`,
	"card": `o7sqHE`,
	"titleContainer": `Ptn66h`,
	"title": `uwq8Dj`,
	"newKeyButton": `DEXjfg`,
	"newKeyIcon": `C3EkW5`,
	"emptyStateContainer": `u7bxYH`,
	"emptyStateContent": `xvARKn`,
	"emptyStateIcon": `tpqXC_`,
	"emptyStateText": `NdmVCC`,
	"emptyStateDescription": `kXO_GC`,
	"registerButton": `C1i24X`,
	"buttonIcon": `tgxHYM`,
	"loadingContainer": `jEGoMu`,
	"errorContainer": `ILWGMk`,
	"errorText": `X68yY5`,
	"keysContainer": `gd7mHn`,
	"keyItem": `SjiVqV`,
	"keyIcon": `G5zmMY`,
	"keyLabel": `bbI3h6`,
	"keyValue": `zETYlz`,
	"copyButton": `FCPhFf`,
	"deleteButton": `iqv9vf`
};
module.exports = ___CSS_LOADER_EXPORT___;
